export default "__VITE_ASSET__DlZBKkzM__"